import axiosInstance from '../config/axios';

export const examsService = {
    // جلب قائمة الاختبارات
    async getExams(params = {}) {
        try {
            const response = await axiosInstance.get('/api/admin/courses/exams', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching exams:', error);
            throw error;
        }
    },

    // إنشاء اختبار جديد
    async createExam(examData) {
        try {
            const response = await axiosInstance.post('/api/admin/courses/exams', examData);
            return response.data;
        } catch (error) {
            console.error('Error creating exam:', error);
            throw error;
        }
    },

    // تحديث اختبار
    async updateExam(examId, examData) {
        try {
            const response = await axiosInstance.put(`/api/admin/courses/exams/${examId}`, examData);
            return response.data;
        } catch (error) {
            console.error('Error updating exam:', error);
            throw error;
        }
    },

    // حذف اختبار
    async deleteExam(examId) {
        try {
            const response = await axiosInstance.delete(`/api/admin/courses/exams/${examId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting exam:', error);
            throw error;
        }
    },

    // جلب تفاصيل اختبار محدد
    async getExam(examId) {
        try {
            const response = await axiosInstance.get(`/api/admin/courses/exams/${examId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching exam details:', error);
            throw error;
        }
    },

    // تغيير حالة الاختبار (نشر/إخفاء)
    async toggleExamStatus(examId, newStatus) {
        try {
            // تغيير الطريقة من PATCH إلى PUT وتغيير المسار
            const response = await axiosInstance.put(`/api/admin/courses/exams/${examId}`, { status: newStatus });
            return response.data;
        } catch (error) {
            console.error('Error toggling exam status:', error);
            throw error;
        }
    },

    // إضافة سؤال جديد
    async createQuestion(examId, questionData) {
        try {
            const response = await axiosInstance.post(`/api/admin/courses/exams/${examId}/questions`, questionData);
            return response.data;
        } catch (error) {
            console.error('Error creating question:', error);
            throw error;
        }
    },

    // تحديث سؤال
    async updateQuestion(examId, questionId, questionData) {
        try {
            const response = await axiosInstance.put(`/api/admin/courses/exams/${examId}/questions/${questionId}`, questionData);
            return response.data;
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    },

    // حذف سؤال
    async deleteQuestion(examId, questionId, hardDelete = true) {
        try {
            // إضافة معلمة permanent=1 للحذف النهائي وحذف الإجابات
            const response = await axiosInstance.delete(`/api/admin/courses/exams/${examId}/questions/${questionId}`, {
                params: { 
                    permanent: hardDelete ? 1 : 0,
                    delete_answers: hardDelete ? 1 : 0  // حذف الإجابات المرتبطة بالسؤال
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting question:', error);
            throw error;
        }
    },

    // جلب أسئلة الاختبار
    async getExamQuestions(examId) {
        try {
            const response = await axiosInstance.get(`/api/admin/courses/exams/${examId}/questions`);
            return response.data;
        } catch (error) {
            console.error('Error fetching exam questions:', error);
            throw error;
        }
    },

    // إضافة إجابة جديدة
    async createAnswer(examId, questionId, answerData) {
        try {
            const response = await axiosInstance.post(`/api/admin/courses/exams/${examId}/questions/${questionId}/answers`, answerData);
            return response.data;
        } catch (error) {
            console.error('Error creating answer:', error);
            throw error;
        }
    },

    // تحديث إجابة
    async updateAnswer(examId, questionId, answerId, answerData) {
        try {
            const response = await axiosInstance.put(`/api/admin/courses/exams/${examId}/questions/${questionId}/answers/${answerId}`, answerData);
            return response.data;
        } catch (error) {
            console.error('Error updating answer:', error);
            throw error;
        }
    },

    // حذف إجابة
    async deleteAnswer(examId, questionId, answerId) {
        try {
            const response = await axiosInstance.delete(`/api/admin/courses/exams/${examId}/questions/${questionId}/answers/${answerId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting answer:', error);
            throw error;
        }
    },

    // جلب إجابات السؤال
    async getAnswers(examId, questionId) {
        try {
            const response = await axiosInstance.get(`/api/admin/courses/exams/${examId}/questions/${questionId}/answers`);
            return response.data;
        } catch (error) {
            console.error('Error fetching answers:', error);
            throw error;
        }
    }
};
